import { LoadingService } from '@/services';
import { EventBus } from '@/event-bus';
import { getContentArea } from '@/contentful';
import store from '@/store';
import Vue from 'vue';

export default Vue.extend({
  methods: {
    openAttachDocumentsScreen(params) {
      LoadingService.watchPromises([
        getContentArea([
          'attach-documents-success',
          'attach-documents-error',
          'attach-documents-error-encrypted-pdf',
          'attach-documents-error-bad-file',
          'attach-documents-guidelines',
        ]),
        store.dispatch('getVaultData'),
      ])
        .then((data) => {
          const CONTENT_AREAS = data[0];
          let paramsObj: any = {};
          if (CONTENT_AREAS) {
            if (CONTENT_AREAS[0] && CONTENT_AREAS[0].fields) {
              paramsObj.successMessage = CONTENT_AREAS[0].fields.content;
            }
            if (CONTENT_AREAS[1] && CONTENT_AREAS[1].fields) {
              paramsObj.errorMessage = CONTENT_AREAS[1].fields.content;
            }
            if (CONTENT_AREAS[2] && CONTENT_AREAS[2].fields) {
              paramsObj.errorEncryptedPDFMessage =
                CONTENT_AREAS[2].fields.content;
            }
            if (CONTENT_AREAS[3] && CONTENT_AREAS[3].fields) {
              paramsObj.errorBadFileMessage = CONTENT_AREAS[3].fields.content;
            }
            if (CONTENT_AREAS[4] && CONTENT_AREAS[4].fields) {
              paramsObj.guidelines = CONTENT_AREAS[4].fields.content;
            }
          }
          paramsObj = Object.assign(paramsObj, params);
          EventBus.$emit(
            'openOverlayWrapper',
            'AttachDocumentsScreen',
            paramsObj,
          );
        })
        .catch(() => {
          EventBus.$emit('openModal', 'Error', {
            message: 'global_connection-error',
          });
        });
    },
  },
});
